import { useCallback, useMemo } from 'react';
import { useLocalStorage } from '@alltrails/local-storage';

const localStorageKey = 'recently-viewed-trails';
const emptyList: number[] = [];
const maxCount = 10;

const useRecentlyViewedTrails = () => {
  const { getValue, setValue } = useLocalStorage(localStorageKey, emptyList);

  const getRecentlyViewedTrails = useCallback(() => {
    return getValue() || emptyList;
  }, [getValue]);

  const addRecentlyViewedTrail = useCallback(
    (trailId: number) => {
      const trails = getValue() || emptyList;

      // If the trail is already in the list, move it to the front
      const updatedTrails = [trailId, ...trails.filter(id => id !== trailId)];
      setValue(updatedTrails.slice(0, maxCount));
    },
    [getValue, setValue]
  );

  return useMemo(
    () => ({
      addRecentlyViewedTrail,
      getRecentlyViewedTrails
    }),
    [addRecentlyViewedTrail, getRecentlyViewedTrails]
  );
};

export default useRecentlyViewedTrails;
